<app-hero-image
  [title]="'Alternatives'"
  [imageUrl]="
    environment.cloudFrontUrl + '/content/alternatives/Alternatives_1.jpg'
  "
></app-hero-image>
<div class="page-content-container">
  <h2 style="margin-top: 0">Alternatives</h2>
  <p style="margin-bottom: 1.5rem">
    Based on the findings in the environmental and traffic studies and feedback
    from the public, the Project Team has worked to refine the potential designs
    for the Choice Lanes. These designs, known as alternatives, consider every
    possible option for a project and go through a rigorous screening process to
    identify the best possible solutions.
  </p>
  <ul class="list-container">
    <li class="list-item">
      <img
        src="assets/icons/no-build-icon.svg"
        alt=""
        class="list-icon"
        aria-hidden="true"
      />
      <span class="list-text">
        A <strong>“no-build” option</strong> option is included in the screening
        process to establish a baseline of conditions and understand any changes
        to those conditions from the alternatives.
      </span>
    </li>
  </ul>

  <p style="margin-bottom: 1.5rem">
    The screening process includes multiple steps with each alternative
    evaluated to determine:
  </p>

  <ul class="list-container">
    <li class="list-item">
      <img
        src="assets/icons/purpose-and-need-icon.svg"
        alt=""
        class="list-icon"
        aria-hidden="true"
      />
      <span class="list-text">Whether they meet the Purpose & Need.</span>
    </li>
    <li class="list-item">
      <img
        src="assets/icons/environmental-icon.svg"
        alt=""
        class="list-icon"
        aria-hidden="true"
      />
      <span class="list-text">
        Impacts to the environment and local communities.
      </span>
    </li>
    <li class="list-item">
      <img
        src="assets/icons/traffic-and-safety-icon.svg"
        alt=""
        class="list-icon collect-icon"
        aria-hidden="true"
      />
      <span class="list-text"> Traffic and safety improvements.</span>
    </li>
  </ul>

  <p>
    Based on the screening results, alternatives are eliminated or continue to
    move forward in the process for further evaluation and public feedback.
    Additional screening will take place to identify one Recommended Preferred
    Alternative to move forward and be presented to the public for additional
    comments and feedback before any final decisions are made.
  </p>

  <h2>Design Refinements</h2>
  <p>
    The Project Team presented two alternatives for public feedback at the
    August 2024 public information meetings. Since those meetings, the Project
    Team has worked to refine designs and incorporate feedback and additional
    environmental and traffic data to develop a refined alternative. This
    refined alternative includes the following changes from those presented in
    August 2024:
  </p>

  <ul class="list-container alternative-list">
    <li class="list-item">
      <img
        src="assets/icons/alternative-icon.svg"
        alt=""
        class="list-icon alternative-icon"
        aria-hidden="true"
      />
      <span class="list-text">
        Adjusted designs to avoid direct impacts to historic properties.
      </span>
    </li>
    <li class="list-item">
      <img
        src="assets/icons/alternative-icon.svg"
        alt=""
        class="list-icon alternative-icon"
        aria-hidden="true"
      />
      <span class="list-text">
        Moved the Choice Lanes to the outside of the mainline on the I-40/I-24
        termination direct merge just beyond Fesslers Lane to reduce traffic
        weaving at this location.
      </span>
    </li>
    <li class="list-item">
      <img
        src="assets/icons/alternative-icon.svg"
        alt=""
        class="list-icon alternative-icon"
        aria-hidden="true"
      />
      <span class="list-text">
        Relocated the Choice Lanes access at E Thompson Lane to Briley Parkway
        to avoid conflicts with planned Bike/Ped projects on E Thompson.
      </span>
    </li>
    <li class="list-item">
      <img
        src="assets/icons/alternative-icon.svg"
        alt=""
        class="list-icon alternative-icon"
        aria-hidden="true"
      />
      <span class="list-text">
        Revised mainline widening design to optimize utilization of the existing
        pavement on the I-24 section between Sam Ridley & I-840.
      </span>
    </li>
    <li class="list-item">
      <img
        src="assets/icons/alternative-icon.svg"
        alt=""
        class="list-icon alternative-icon"
        aria-hidden="true"
      />
      <span class="list-text">
        Increased the number of Choice Lanes to two (2) in each direction for
        the southern section from Rocky Fork Road to I-840.
      </span>
    </li>
    <li class="list-item">
      <img
        src="assets/icons/alternative-icon.svg"
        alt=""
        class="list-icon alternative-icon"
        aria-hidden="true"
      />
      <span class="list-text">
        Added bridge replacements for I-24 over Mill Creek and I-24 over Bell
        Road to replace aging bridges and address flooding on I-24 at Mill
        Creek.
      </span>
    </li>
    <li class="list-item">
      <img
        src="assets/icons/alternative-icon.svg"
        alt=""
        class="list-icon alternative-icon"
        aria-hidden="true"
      />
      <span class="list-text">
        Added interchange improvements at Almaville Road.
      </span>
    </li>
    <li class="list-item">
      <img
        src="assets/icons/alternative-icon.svg"
        alt=""
        class="list-icon alternative-icon"
        aria-hidden="true"
      />
      <span class="list-text">
        Expanded ramps through the system-to-system interchanges on I-24 at I-40
        and I-440 to accommodate two (2) lane ramps and operations with HCVs.
        Expanded ramps through the system to system-to-system interchanges on
        I-24 at I-40 and I-440 to accommodate two (2) lane ramps and operations
        with HCVs.
      </span>
    </li>
    <li class="list-item">
      <img
        src="assets/icons/alternative-icon.svg"
        alt=""
        class="list-icon alternative-icon"
        aria-hidden="true"
      />
      <span class="list-text">
        Adjusted the Choice Lanes northern terminus near Downtown loop to
        improve merging operations.
      </span>
    </li>
  </ul>

  <div class="pdf-grid">
    <app-pdf-viewer
      [pdfUrl]="pdfDocuments[0].url"
      [title]="pdfDocuments[0].title"
      [thumbnailUrl]="pdfDocuments[0].thumbnail"
      containerId="adobe-dc-view-1"
    ></app-pdf-viewer>
  </div>

  <app-call-out-box
    [content]="
      '<p>Want a more in-depth look at the refined alternative? Take a look at the materials linked below.</p>'
    "
  ></app-call-out-box>

  <h2>Visualization Video</h2>
  <div class="video-wrapper" style="margin-bottom: 80px">
    <iframe
      src="https://www.youtube.com/embed/LHQ80c6fWsI?si=vGyz92J6o87NteM2"
      title="I-24 Southeast Choice Lanes Project Overview"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerpolicy="strict-origin-when-cross-origin"
      allowfullscreen
    ></iframe>
  </div>

  <div class="pdf-grid">
    <app-pdf-viewer
      [pdfUrl]="pdfDocuments[1].url"
      [title]="pdfDocuments[1].title"
      [thumbnailUrl]="pdfDocuments[1].thumbnail"
      containerId="adobe-dc-view-2"
    ></app-pdf-viewer>
    <app-pdf-viewer
      [pdfUrl]="pdfDocuments[2].url"
      [title]="pdfDocuments[2].title"
      [thumbnailUrl]="pdfDocuments[2].thumbnail"
      containerId="adobe-dc-view-3"
    ></app-pdf-viewer>
  </div>
</div>
